import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Tel extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Tel {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new Tel(value);
  }

  /** ラベル */
  static get label(): string {
    return '電話番号';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '090-1234-1234';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'tel';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      pattern: {
        /** 値 */
        value: /^0\d{1,3}-\d{2,4}-\d{3,4}$/,
        /** メッセージ */
        message: '電話番号の形式が不正です',
      },
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
